module.exports = __webpack_public_path__ + "img/brydg.51baacad.svg";